import { Modal, Button } from 'Common/Supplyvue-ui'
import { Box, Typography } from '@mui/material'

export const NavigationModal = ({
  open,
  handleCancel,
  handleProceed,
}: {
  open: boolean
  handleCancel: () => void
  handleProceed: () => void
}) => {
  const body = (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      sx={{
        width: '500px',
        height: '125px',
      }}
    >
      <Typography variant="body1">
        You have unsaved changes, are you sure you want to leave and discard
        your changes?
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        gap="4px"
      >
        <Button variant="outlined" onClick={() => handleCancel()}>
          Cancel
        </Button>
        <Button variant="contained" onClick={() => handleProceed()}>
          Yes
        </Button>
      </Box>
    </Box>
  )

  return (
    <Modal
      open={open}
      handleClose={handleCancel}
      header={'Discard changes'}
      body={body}
    />
  )
}
